// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const VacationTypes:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  const gridParams = {
    grids: [{ name: 'absenceTypes', hashCache }],
  }

  return <Table
    api={axiosAPI.settings.vacationTypes.table}
    apiParams={apiParams}
    gridName="absenceTypes"
    gridParams={gridParams}
  />;
}

function VacationTypesPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<VacationTypes hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default VacationTypesPortal;
